const initialState = {
  year: "year1",
};
const ActiveYearReducer = (state = initialState, action) => {
  switch (action.type) {
    case "TOGGLE_YEAR":
      return (initialState.year = action.payload);
    default:
      return state;
  }
};

export default ActiveYearReducer;
